export const features = [
  {
    id: 1,
    icon: 'ri-smartphone-line',
    title: '智能推荐',
    description: '基于AI深度学习算法，精准分析您的兴趣偏好，为您推荐量身定制的优质短视频内容，越用越懂你。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '支持4K超高清视频播放，搭配HDR显示技术，让每一帧画面都细腻震撼，带来影院级观看体验。',
  },
  {
    id: 3,
    icon: 'ri-download-2-line',
    title: '离线缓存',
    description: '一键下载精彩视频到本地存储，无网络也能畅享内容。支持多种清晰度选择，灵活管理存储空间。',
  },
  {
    id: 4,
    icon: 'ri-live-line',
    title: '高清直播',
    description: '支持实时高清直播互动，弹幕聊天、虚拟礼物、PK连麦等功能让直播更加精彩有趣。',
  },
  {
    id: 5,
    icon: 'ri-edit-2-line',
    title: '创作工具',
    description: '内置专业级视频编辑工具，丰富的滤镜、特效、音乐素材库，零基础也能轻松创作爆款视频。',
  },
  {
    id: 6,
    icon: 'ri-shield-check-line',
    title: '安全保护',
    description: '多重安全防护机制，青少年模式、隐私设置、账号保护等功能全面守护您的使用安全。',
  },
  {
    id: 7,
    icon: 'ri-group-line',
    title: '社区互动',
    description: '点赞、评论、分享、私信等多种社交互动方式，让您与创作者和其他用户建立真实连接。',
  },
  {
    id: 8,
    icon: 'ri-global-line',
    title: '海量内容',
    description: '涵盖搞笑、音乐、舞蹈、美食、旅行、科技、运动、时尚等数十个品类，总有您感兴趣的内容。',
  },
];

export const faqs = [
  {
    question: '抖阴pro是免费的吗？',
    answer: '是的，抖阴pro完全免费下载和使用。您可以在官方渠道免费下载安装，观看所有公开的短视频内容。部分增值服务（如虚拟礼物、会员特权等）为可选付费项目。',
  },
  {
    question: '抖阴pro支持哪些手机系统？',
    answer: '抖阴pro目前支持Android 8.0及以上版本和iOS 14.0及以上版本。我们建议您将手机系统更新到最新版本以获得最佳体验。',
  },
  {
    question: '如何下载抖阴pro最新版本？',
    answer: 'Android用户请访问官方网站下载最新APK安装包；iOS用户请在App Store搜索"抖阴pro"下载。建议开启自动更新功能，以便第一时间体验新功能。',
  },
  {
    question: '抖阴pro会消耗很多流量吗？',
    answer: '抖阴pro采用智能码率调节技术，在网络状况良好时自动匹配最佳清晰度。您也可以在设置中选择默认播放清晰度（流畅/高清/超清），或开启"仅WiFi下播放高清"来节省移动流量。',
  },
  {
    question: '如何在抖阴pro上发布视频？',
    answer: '注册登录后，点击底部"+"按钮即可进入拍摄或上传页面。您可以直接拍摄视频，或从相册选择已录制好的视频。上传后可使用内置编辑工具进行剪辑、添加滤镜和音乐等操作。',
  },
  {
    question: '抖阴pro账号可以注销吗？',
    answer: '可以。请前往「我」→「设置」→「账号与安全」→「注销账号」，按照提示完成身份验证后即可申请注销。请注意，注销后所有数据将无法恢复。',
  },
  {
    question: '青少年如何使用抖阴pro？',
    answer: '抖阴pro为未成年用户提供青少年模式。家长可以在「设置」→「青少年模式」中为孩子开启，设置使用时长限制、内容过滤和消费管理，为孩子营造健康安全的网络环境。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '您可以通过以下方式联系我们：1）在App内「我」→「设置」→「帮助与反馈」提交问题；2）发送邮件至support@douyinpro.com；3）访问官方网站的"联系我们"页面留言。我们会在24小时内回复。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '王小明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20man%20with%20warm%20friendly%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20corporate%20portrait%20photography&width=80&height=80&seq=avatar-1&orientation=squarish',
    role: '资深用户',
    content: '用了抖阴pro快两年了，推荐算法真的很准，每次打开都能刷到我喜欢的内容。离线下载功能也很实用，地铁上也能看。',
    rating: 5,
  },
  {
    id: 2,
    name: '李美琪',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20woman%20with%20genuine%20warm%20smile%2C%20clean%20light%20background%2C%20soft%20natural%20studio%20lighting%2C%20beautiful%20portrait%20photography&width=80&height=80&seq=avatar-2&orientation=squarish',
    role: '内容创作者',
    content: '作为创作者，抖阴pro的创作工具真的是我用过最好用的。内置的剪辑功能和素材库非常丰富，大大提高了我的创作效率。',
    rating: 5,
  },
  {
    id: 3,
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20man%20with%20confident%20expression%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20modern%20portrait%20photography&width=80&height=80&seq=avatar-3&orientation=squarish',
    role: '普通用户',
    content: '界面简洁好上手，家里老人也能轻松使用。内容种类丰富，从美食到旅行，每天刷一刷能学到不少新东西。',
    rating: 4,
  },
  {
    id: 4,
    name: '赵雪',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20woman%20with%20bright%20smile%2C%20clean%20white%20background%2C%20soft%20flattering%20studio%20lighting%2C%20friendly%20portrait%20photography&width=80&height=80&seq=avatar-4&orientation=squarish',
    role: '学生用户',
    content: '青少年模式让家长很放心，学习累了刷刷视频放松一下。安全保护功能做得很好，不用担心隐私问题。',
    rating: 5,
  },
];

export const statsData = [
  { label: '累计用户', value: '5.8亿+', icon: 'ri-user-line' },
  { label: '日活跃用户', value: '8200万+', icon: 'ri-fire-line' },
  { label: '内容创作者', value: '1200万+', icon: 'ri-edit-line' },
  { label: '日均视频播放', value: '320亿+', icon: 'ri-play-circle-line' },
];